import type { AdminEnvironment } from "@/lib/environment";

interface ProdConfirmModalProps {
  environment: AdminEnvironment;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ProdConfirmModal({ environment, onCancel, onConfirm }: ProdConfirmModalProps) {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/30 p-4">
      <div className="w-full max-w-[420px] rounded-xl border border-surface-border bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-surface-border px-5 py-4">
          <h3 className="text-base font-semibold text-text-primary">确认切换生产环境</h3>
          <button
            type="button"
            onClick={onCancel}
            className="flex h-8 w-8 items-center justify-center rounded-lg text-text-muted hover:bg-surface"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>
        <div className="space-y-4 px-5 py-5">
          <div className="rounded-lg border border-status-warning/30 bg-status-warning/10 px-4 py-3 text-sm text-text-secondary">
            当前将切换到 <span className="font-semibold text-status-warning">{environment.display_name}</span>。
            生产环境操作会影响真实业务。
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="h-10 rounded-lg border border-surface-border px-4 text-sm text-text-secondary hover:bg-surface"
            >
              取消
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="h-10 rounded-lg bg-status-warning px-4 text-sm font-medium text-white hover:opacity-90"
            >
              确认切换
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
